import React, { useState, useEffect } from 'react';
import { useLangContext } from 'components/shared/Lang';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { DocLayout } from 'components/ant/layouts';
import { useRouter } from 'next/router';
import { Spin } from 'antd';
import Link from 'components/shared/elements/Link';
import { API_ROOT } from 'modules/request';
import styles from 'components/ant/css/indexStyles.module.css';

const DocsPage = () => {
  const { t, lang } = useLangContext();
  const router = useRouter();
  const { url } = router.query;

  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!url) return;

    const currentLang = lang || router.locale || 'ru';
    setLoading(true);
    setNotFound(false);

    fetch(`/api/docs/by-url/${url}?lang=${currentLang}`)
      .then((r) => {
        if (r.status === 404) {
          setNotFound(true);
          return null;
        }
        return r.json();
      })
      .then((data) => {
        if (data) setDoc(data);
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [url, lang, router.locale]);

  if (loading) {
    return (
      <DocLayout title={t('Document')}>
        <div style={{ padding: 48, textAlign: 'center' }}>
          <Spin size='large' />
        </div>
      </DocLayout>
    );
  }

  if (notFound || (!loading && !doc && url)) {
    return (
      <DocLayout title={t('Not found')}>
        <div className={styles.docDiv}>
          <div className={styles.docDiv1}>
            <Link href='/'>{t('home')}</Link>
          </div>
          <h1 className={styles.docH1}>{t('Document not found')}</h1>
        </div>
      </DocLayout>
    );
  }

  return (
    <DocLayout title={doc?.title || t('Document')}>
      <div className={styles.docDiv}>
        <h1 className={styles.docH1}>{doc?.title}</h1>
        {doc?.image && (
          <img
            src={doc.image}
            alt={doc.title}
            style={{ maxWidth: 720, width: '100%', borderRadius: 8, marginBottom: 24 }}
          />
        )}
        <div
          className={styles.docDiv2}
          dangerouslySetInnerHTML={{ __html: doc?.body || '' }}
        />
      </div>
    </DocLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  ctx.res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=59');

  return {
    props: {
      ...(await serverSideTranslations(ctx.locale, ['common'])),
    },
  };
};

export default DocsPage;
